import { useEffect, useRef, useState } from "react"

import { Input } from 'twyne-new.ui'

export default function EditingTitle({ value, isEditing, isNew }) {
  const [title, setTitle] = useState(value.valueOf())
  const inputRef = useRef(null)
  const editing = isNew.value || isEditing.value

  useEffect(() => {
    setTimeout(() => {
      if (editing) {
        inputRef.current?.focus()
        inputRef.current?.select()
      }
    }, 200)
  }, [editing])

  const handleEditFinish = () => {
    value.setValue(title)
    isEditing.setValue(false)
    isNew.setValue(false)
  }

  if (!editing) {
    return <div>
      {title}
    </div>
  }

  return <div className='-m-1'>
    <Input
      ref={inputRef}
      className='p-1'
      variant={'accent'}
      value={title}
      onChange={e => setTitle(e.target.value)}
      onBlur={handleEditFinish}
      onClick={evt => evt.stopPropagation()}
      onKeyDown={evt => evt.key === 'Enter' && handleEditFinish()}
      autoFocus
    />
  </div>
}
